import {
  apiRequest,
  skp3kUpdate,
  skp3kDetail,
  masterRank,
  masterSignatoryOfficial,
  masterDocumentType,
} from "../../../../../services/adapters/kepegawaian/skp3kService";

class UpdateRepository {
  fetchUpdate = async (query) => {
    return await apiRequest(
      "post",
      skp3kUpdate,
      {
        body: query,
      },
      true
    );
  };

  fetchDetail = async (query) => {
    return await apiRequest(
      "get",
      skp3kDetail,
      {
        params: query,
      },
      true
    );
  };

  fetchRank = async (query) => {
    return await apiRequest(
      "get",
      masterRank,
      {
        params: query,
      },
      true
    );
  };

  fetchSignatoryOfficial = async (query) => {
    return await apiRequest(
      "get",
      masterSignatoryOfficial,
      {
        params: query,
      },
      true
    );
  };

  fetchDocumentType = async (query) => {
    return await apiRequest(
      "get",
      masterDocumentType,
      {
        params: query,
      },
      true
    );
  };
}

export default UpdateRepository;
